import { UrlProviderService } from './local/url-provider.service';
import { HttpinterceptorService } from './httpinterceptor';
import * as i0 from "@angular/core";
import * as i1 from "./httpinterceptor";
import * as i2 from "./local/url-provider.service";
export class LookupService {
    constructor(http, urlProvider) {
        this.http = http;
        this.urlProvider = urlProvider;
        this.TaxOffices = new Array();
    }
    getCountries() {
        var url = this.urlProvider.getCountriesURL();
        return this.http.getRequest(url).toPromise().then((res) => res);
    }
    getCities(countryCode) {
        var url = this.urlProvider.getCities(countryCode);
        return this.http.getRequest(url).toPromise().then((res) => res);
    }
    getErps() {
        var url = this.urlProvider.getErpsURL();
        return this.http.getRequest(url).toPromise().then((res) => res);
    }
    getUsageTypes() {
        var url = this.urlProvider.getUsageTypesURL();
        return this.http.getRequest(url).toPromise().then((res) => res);
    }
    getTaxOffices() {
        var url = this.urlProvider.getTaxOfficesURL();
        return this.http.getRequest(url).toPromise().then((res) => res);
    }
}
LookupService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LookupService_Factory() { return new LookupService(i0.ɵɵinject(i1.HttpinterceptorService), i0.ɵɵinject(i2.UrlProviderService)); }, token: LookupService, providedIn: "root" });
